.container {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 1rem;
}

.card {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

.title {
  margin: 0;
  font-size: 1.5rem;
}

.muted {
  margin: 0;
  color: var(--muted);
  font-size: 0.95rem;
}

.label {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.9rem;
  color: var(--muted);
}

.input {
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg);
  color: var(--text);
}

.input:focus {
  outline: 2px solid var(--accent);
  outline-offset: -1px;
}

.submit {
  margin-top: 0.5rem;
  padding: 0.65rem 1rem;
  background: var(--accent);
  color: white;
  border: 0;
  border-radius: 8px;
  font-weight: 600;
}

.submit:hover:not(:disabled) {
  background: var(--accent-hover);
}

.submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
